import { render, staticRenderFns } from "./tip.vue?vue&type=template&id=3a1af660&"
import script from "./tip.vue?vue&type=script&lang=js&"
export * from "./tip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a1af660')) {
      api.createRecord('3a1af660', component.options)
    } else {
      api.reload('3a1af660', component.options)
    }
    module.hot.accept("./tip.vue?vue&type=template&id=3a1af660&", function () {
      api.rerender('3a1af660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/_tip/src/tip.vue"
export default component.exports